"use strict";
/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * ČVS - API
 * OpenAPI spec version: 1.1.529
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelRegistrationParamsResponseReasonType = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.CancelRegistrationParamsResponseReasonType = {
    oddil: 'oddil',
    clen: 'clen',
    smrt: 'smrt',
};
